import React from 'react';

// Les accessoires sont detoures : on les pose sur une ligne de sol avec une
// ombre portee, comme les machines, pour que les quatre cartes se tiennent.

export default function CarteAccessoire({ accessoire, hauteur = 180 }) {
  const detoure = Boolean(accessoire.detoure);

  return (
    <div className="carte overflow-hidden h-full flex flex-col group">
      <div
        className={`relative flex items-end justify-center overflow-hidden ${
          detoure
            ? 'bg-gradient-to-b from-trame via-trame to-white px-3 pt-4'
            : 'bg-white p-3 items-center'
        }`}
        style={{ height: `${hauteur + 46}px` }}
      >
        {detoure && (
          <>
            <span className="absolute bottom-[22px] left-0 right-0 h-px bg-nuit/10" aria-hidden="true" />
            <span
              className="absolute bottom-[15px] left-1/2 -translate-x-1/2 w-[70%] h-[14px] rounded-[50%] bg-nuit/25 blur-[7px] transition-all duration-500 group-hover:w-[74%]"
              aria-hidden="true"
            />
          </>
        )}
        <img
          src={accessoire.image}
          alt={accessoire.nom}
          loading="lazy"
          className={`relative object-contain w-auto transition-transform duration-500 ${
            detoure
              ? 'mb-[18px] group-hover:scale-[1.05] group-hover:-translate-y-0.5'
              : 'max-h-full max-w-full'
          }`}
          style={detoure ? { maxHeight: `${hauteur}px` } : undefined}
        />
      </div>

      <div className="px-5 py-4 border-t border-nuit/10">
        <p className="font-cond uppercase font-bold tracking-[0.03em] text-[16px] text-nuit">
          {accessoire.nom}
        </p>
        <p className="text-[14.5px] text-beton mt-1">{accessoire.detail}</p>
      </div>
    </div>
  );
}
